import React from "react";
import { Props_SnippetSpacer } from "./Spacer.props";

const SnippetSpacer = (props: Props_SnippetSpacer) => {
    const { spacerProps } = props;
    const { mobileHeight, desktopHeight, backgroundColor } = spacerProps;

    const snippetClass = `snippet-spacer snippet-spacer--mobile-${mobileHeight?.value} snippet-spacer--desktop-${desktopHeight?.value} snippet-spacer--bg--${backgroundColor?.value}`;

    return (
        <div
        className={snippetClass}
        role="presentation"
        ></div>
    );
};

export default SnippetSpacer;